
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke162aRequest, Sgke162aResponse, Sgke162aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke162aService {

  /**
   * コンストラクタ
   * @param {Sgke162aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke162aService
   */
  constructor(
    public service: Sgke162aService,
    public apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE162A_入金締め検索API呼び出し
   * @param {Sgke162aRequest} request 
   * @returns {Observable<Sgke162aResponse>}
   * @memberof UsedSgke162aService
   */
  public doSgke162a(request: Sgke162aRequest): Observable<Sgke162aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.sgke162aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE162A');
          return throwError(err.message);
        })
      );
  }

}
